
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

const useEstudiando = () => {

    // variables
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [estaEstudiando, setEstaEstudiando] = useState( false )
    const estudiosInicial = {
        funcion: 'guardarCarrerasEstudiando',
        institucion: '',
        carrera: '',
        correo: objLogueado.email
    }
    const { URL } = url()
    const [estudiosActuales, setEstudiosActuales] = useState([])
    const [formEstudios, setFormEstudios] = useState( estudiosInicial )
    const [pkEstudioActual, setPkEstudioActual] = useState( 0 )
    const [isOpen, setIsOpen] = useState( false )
    const [cargando, setCargando] = useState( false )



    // funciones
    const traerEstudiosActuales = () => {

        var fd = new FormData()
        fd.append("funcion", "traerEstudiosActuales")
        fd.append("correo", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setEstudiosActuales( e )
            if ( e.length > 0 ) {
                setEstaEstudiando( true )
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la información de tus estudios actuales', 'error' )
        })
    }


    const guardarEstudiando = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formEstudios, pkEstudioActual })
        })
        .then( res => res.json() )
        .then( function (d) {
            traerEstudiosActuales()
            if ( d.codigo === 1 && pkEstudioActual === 0 ) {
                elToast( d.mensaje )
                setFormEstudios( estudiosInicial )
            } else if ( d.codigo === 0 ) {
                elToast( d.mensaje, 'error' )
            } else if ( d.codigo === 1 ) {
                elToast( d.mensaje )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
        })
        .finally( () => setCargando( false ) )
    }

    const editarEstudiando = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formEstudios, pk_estudiando: pkEstudioActual, funcion: 'editarCarrerasEstudiando', })
        })
        .then( res => res.json() )
        .then( function (d) {
            traerEstudiosActuales()
            if ( d.codigo === 1 ) {
                // si se guardó
                elToast( d.mensaje )
                setFormEstudios( estudiosInicial )
                cerrarModal()
            } else if ( d.codigo === 0 ) {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
        })
        .finally( () => setCargando( false ) )
    }


    function borrarEstudiando( pk_estudiando ) {
        if ( pk_estudiando && window.confirm("El registro será eliminado.") ) {
            fetch( URL, {
                method: 'post',
                body: JSON.stringify({ pk_estudiando: pk_estudiando, funcion: 'borrarEstudiando' })
            })
            .then( res => res.json() )
            .then( function (d) {
                if ( d.codigo === 1 ) {
                    traerEstudiosActuales()
                    elToast( 'Eliminado con éxito' )
                } else {
                    elToast( d.mensaje, 'info' )
                }
            })
            .catch( a => {
                elToast( "Error al eliminar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
            })
        }
    }

    const abrirModal = ( borrar_pk = true ) => {
        setIsOpen( true )
        if ( borrar_pk ) {
            setPkEstudioActual( 0 )
        }
    }

    const cerrarModal = () => {
        setIsOpen( false )
        setFormEstudios( estudiosInicial )
    }

    function llenarFormEstudios( e ) {
        setFormEstudios({
            funcion: 'editarCarrerasEstudiando',
            institucion: e.institucion,
            carrera: e.carrera,
            correo: objLogueado.email
        })
        setPkEstudioActual( e.pk_estudiando )
        abrirModal( false )
    }


    // useEffects
    useEffect(() => {
        traerEstudiosActuales()
        // eslint-disable-next-line
    }, [])


    return {
        estudiosActuales,estaEstudiando, setEstaEstudiando,
        cargando, guardarEstudiando,
        formEstudios, setFormEstudios,
        llenarFormEstudios, isOpen, cerrarModal,
        editarEstudiando, borrarEstudiando
    }
}

export default useEstudiando
